import StatusBadge from './StatusBadge';
import { formatDateTime } from '../utils/formatDate';

const StatusHistory = ({ history }) => {
  const items = Array.isArray(history)
    ? [...history].sort((a, b) => new Date(b.changed_at) - new Date(a.changed_at))
    : [];

  return (
    <div className="card mb-3">
      <div className="card-header bg-white">
        <h3 className="fs-6 mb-0">Status History</h3>
      </div>
      {items.length === 0 ? (
        <div className="card-body">
          <p className="text-muted mb-0">No status changes recorded yet.</p>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table mb-0">
            <thead className="table-light border-light">
              <tr>
                <th>Status</th>
                <th>Changed</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={`${item.changed_at}-${item.status}-${index}`}>
                  <td>{item.status ? <StatusBadge status={item.status} /> : 'N/A'}</td>
                  <td>{formatDateTime(item.changed_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default StatusHistory;
